import * as React from 'react';

import { type Links, consumerLinks } from 'bundles/megamenu/constants/simplifiedMegaMenuContent';
import MegaMenuLinksContext from 'bundles/megamenu/contexts/MegaMenuLinksContext';

type MegaMenuLinksProviderProps = {
  links?: Links;
  isEnterprise?: boolean;
  children: React.ReactNode;
};
const MegaMenuLinksProvider = ({ links = consumerLinks(), isEnterprise, children }: MegaMenuLinksProviderProps) => {
  return (
    <MegaMenuLinksContext.Provider value={{ links, isEnterprise: !!isEnterprise }}>
      {children}
    </MegaMenuLinksContext.Provider>
  );
};

export default MegaMenuLinksProvider;
